import { render, staticRenderFns } from "./RegisterSchool.vue?vue&type=template&id=2b51e1d2&lang=pug&"
import script from "./RegisterSchool.vue?vue&type=script&lang=js&"
export * from "./RegisterSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports